import type { CSSProperties, MouseEventHandler } from 'react'
import type { ResponsiveImageData } from '../data/images'
import { publicAsset } from '../utils/publicAsset'

type ResponsiveImageProps = {
  image: ResponsiveImageData
  alt: string
  sizes?: string
  className?: string
  objectFit?: CSSProperties['objectFit']
  objectPosition?: string
  priority?: boolean
  onClick?: MouseEventHandler<HTMLImageElement>
}

function srcSet(variants: ResponsiveImageData['sources']['avif']) {
  return variants.map(({ src, width }) => `${publicAsset(src)} ${width}w`).join(', ')
}

export function ResponsiveImage({
  image,
  alt,
  sizes = '100vw',
  className,
  objectFit,
  objectPosition,
  priority = false,
  onClick,
}: ResponsiveImageProps) {
  const style: CSSProperties | undefined = objectFit || objectPosition ? { objectFit, objectPosition } : undefined

  return (
    <picture className={`responsive-image${className ? ` ${className}` : ''}`}>
      <source type="image/avif" srcSet={srcSet(image.sources.avif)} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(image.sources.webp)} sizes={sizes} />
      <img
        src={publicAsset(image.fallback)}
        srcSet={srcSet(image.sources.jpeg)}
        sizes={sizes}
        alt={alt}
        width={image.width}
        height={image.height}
        loading={priority ? 'eager' : 'lazy'}
        decoding={priority ? 'sync' : 'async'}
        fetchPriority={priority ? 'high' : 'auto'}
        style={style}
        onClick={onClick}
      />
    </picture>
  )
}
